import axios from "axios"
import { useNavigate } from 'react-router-dom'
import { getId, getToken, useGlobalSettings, useSettings } from "../../user/User"
import { toast } from "react-toastify"
import FormButton from "../../components/FormButton"

const Settings = () => {
    const navigate = useNavigate()

    let { twoFactorAuthenticationEnabled, setTwoFactorAuthenticationEnabled } = useSettings(getId())
    let { monthlyGoal, setMonthlyGoal, lowPrioTaskDeadlineInDays, setLowPrioTaskDeadlineInDays, mediumPrioTaskDeadlineInDays, setMediumPrioTaskDeadlineInDays,
        highPrioTaskDeadlineInDays, setHighPrioTaskDeadlineInDays, serviceAgreementDeadlineInDays, setServiceAgreementDeadlineInDays } = useGlobalSettings()

    async function enableTwoFactorAuthentication() {
        navigate("/settings/enable2fa")
    }

    async function disableTwoFactorAuthentication() {
        axios.get(process.env.REACT_APP_API_URL + "/api/settings/2fa/disable", { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            toast.success("Disabled two factor authentication")
            setTwoFactorAuthenticationEnabled(false)
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    const onSaveGlobalSettings = async e => {
        e.preventDefault()

        axios.put(process.env.REACT_APP_API_URL + "/api/globalsettings", JSON.stringify({
            "monthly_goal": parseInt(monthlyGoal),
            "low_prio_task_deadline_in_days": parseInt(lowPrioTaskDeadlineInDays),
            "medium_prio_task_deadline_in_days": parseInt(mediumPrioTaskDeadlineInDays),
            "high_prio_task_deadline_in_days": parseInt(highPrioTaskDeadlineInDays),
            "service_agreement_deadline_in_days": parseInt(serviceAgreementDeadlineInDays),
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            toast.success("Saved global settings.")
        }).catch(_ => {
            toast.error("Internal error")
        })
    }

    return (
        <>
            <div className="card card-primary">
                <div className="card-header">
                    Global settings    
                </div>
                    <form className="form-horizontal">
                    <div className="card-body">
                        <div className="row">
                            <FormButton label="Monthly goal" id="monthlyGoal" required="required" type="number" value={monthlyGoal} setValue={setMonthlyGoal} icon="fa-solid fa-money-bill" />
                            <FormButton label="Service agreement deadline in days" id="serviceAgreementDeadlineInDays" required="required" type="number" value={serviceAgreementDeadlineInDays} setValue={setServiceAgreementDeadlineInDays} icon="fa-solid fa-timer" />
                        </div>
                    </div>

                    <div className="card-body">
                        <span>Task deadline in days</span>
                        <div className="row">
                            <FormButton label="Low priority" id="lowPrioTaskDeadlineInDays" required="required" type="number" value={lowPrioTaskDeadlineInDays} setValue={setLowPrioTaskDeadlineInDays} icon="fa-solid fa-timeline" />
                            <FormButton label="Medium priority" id="mediumPrioTaskDeadlineInDays" required="required" type="number" value={mediumPrioTaskDeadlineInDays} setValue={setMediumPrioTaskDeadlineInDays} icon="fa-solid fa-timeline" />
                            <FormButton label="High priority" id="highPrioTaskDeadlineInDays" required="required" type="number" value={highPrioTaskDeadlineInDays} setValue={setHighPrioTaskDeadlineInDays} icon="fa-solid fa-timeline" />
                        </div>
                    </div>
                </form>
                <div className="card-footer">
                    <button className="btn btn-success" onClick={onSaveGlobalSettings}>Save global settings</button>
                </div>
            </div>

            <br />

            <div className="card card-primary">
                <div className="card-header">
                    User settings    
                </div>
                <div className="card-body">
                    <form className="form-horizontal">
                        <div className="col-12">
                            <p>
                                Two-factor authentication&nbsp;
                                <button type="button" className="btn btn-success" disabled={twoFactorAuthenticationEnabled} onClick={enableTwoFactorAuthentication}>Enable</button>&nbsp;
                                <button type="button" className="btn btn-danger" disabled={!twoFactorAuthenticationEnabled} onClick={disableTwoFactorAuthentication}>Disable</button>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Settings